module.exports = __webpack_public_path__ + "static/media/330km.7f7c5187.jpg";